/**
 * Determines whether the matched string is a strict match against the input.
 * Useful for validation scenarios to check exact conformance.
 */
export function isStrictMatch(match: string, input: string): boolean {
  return match.trim() === input.trim();
}
